var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2009_2044)","key":0},React.createElement("path",{"d":"M14.2359 10.1635L22.9783 0.00109863H20.9067L13.3156 8.82493L7.25266 0.00109863H0.259766L9.42813 13.3443L0.259766 24.0011H2.33156L10.3479 14.6828L16.7508 24.0011H23.7437L14.2354 10.1635H14.2359ZM11.3983 13.4619L10.4694 12.1332L3.07805 1.56071H6.26021L12.2251 10.093L13.154 11.4217L20.9076 22.5124H17.7255L11.3983 13.4624V13.4619Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2009_2044"},React.createElement("rect",{"width":"24","height":"23.9993","fill":"white","transform":"translate(0 0.000366211)"})))]);
}

X.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","role":"img","aria-label":"Twitter svg image"};

module.exports = X;

X.default = X;
